module.exports = __webpack_public_path__ + "img/ghonaim-hero.6b06d54c.webp";